import { useEffect } from 'react';
import { usePlatformSettings } from '../../contexts/PlatformContext';

const DynamicPageTitle = ({ pageTitle = '', clubMode = false }) => {
  const platformSettings = usePlatformSettings();

  useEffect(() => {
    // جلب بيانات النادي من localStorage إذا كان في وضع النادي
    let clubData = null;
    if (clubMode) {
      try {
        const userData = localStorage.getItem('user');
        if (userData) {
          const user = JSON.parse(userData);
          clubData = {
            name: user.club_name || 'النادي',
            id: user.club_id
          };
        }
      } catch (error) {
        console.error('خطأ في قراءة بيانات النادي:', error);
      }
    }

    // تحديد العنوان النهائي
    let finalTitle;
    if (clubMode && clubData) {
      // وضع النادي: اسم النادي + اسم الصفحة + اسم المنصة
      const basePlatformName = platformSettings?.platform_name || 'منصة الأندية الرياضية';
      if (pageTitle) {
        finalTitle = `${pageTitle} - ${clubData.name} - ${basePlatformName}`;
      } else {
        finalTitle = `${clubData.name} - ${basePlatformName}`;
      }
    } else {
      // الوضع العادي: اسم الصفحة + اسم المنصة
      const basePlatformName = platformSettings?.platform_name || 'منصة الأندية الرياضية';
      finalTitle = pageTitle ? `${pageTitle} - ${basePlatformName}` : basePlatformName;
    }
    
    // تحديث عنوان الصفحة
    document.title = finalTitle;
    
    // تحديث meta tags
    updateMetaTags(finalTitle, clubData);
    
  }, [platformSettings, pageTitle, clubMode]);

  const updateMetaTags = (fullTitle, clubData) => {
    // تحديث meta title
    const metaTitle = document.querySelector('meta[name="title"]');
    if (metaTitle) {
      metaTitle.content = fullTitle;
    }
    
    // تحديث meta description مع بيانات النادي
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      const description = clubData 
        ? `الموقع الرسمي لـ ${clubData.name}. تابع آخر الأخبار، المباريات واللاعبين.`
        : `منصة شاملة لإدارة الأندية الرياضية مع أحدث التقنيات والأدوات المتقدمة.`;
      metaDescription.content = description;
    }
    
    // تحديث Open Graph tags
    const ogTitle = document.querySelector('meta[property="og:title"]');
    if (ogTitle) {
      ogTitle.content = fullTitle;
    }
    
    const ogDescription = document.querySelector('meta[property="og:description"]');
    if (ogDescription) {
      const description = clubData 
        ? `تابع آخر أخبار ${clubData.name}، المباريات واللاعبين`
        : `تابع آخر أخبار المنصة، المباريات واللاعبين`;
      ogDescription.content = description;
    }
    
    // تحديث Twitter tags
    const twitterTitle = document.querySelector('meta[name="twitter:title"]');
    if (twitterTitle) {
      twitterTitle.content = fullTitle;
    }
    
    const twitterDescription = document.querySelector('meta[name="twitter:description"]');
    if (twitterDescription) {
      const description = clubData 
        ? `تابع آخر أخبار ${clubData.name}، المباريات واللاعبين`
        : `تابع آخر أخبار المنصة، المباريات واللاعبين`;
      twitterDescription.content = description;
    }
    
    console.log(`✅ تم تحديث عنوان الصفحة: ${document.title}`);
    if (clubData) {
      console.log(`🏟️ معلومات النادي: ${clubData.name} (${clubData.id})`);
    }
  };

  return null; // مكون صامت لا يعرض أي محتوى
};

export default DynamicPageTitle;